import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { X, BadgePercent } from "lucide-react";
import { getAffiliateRef } from "@/lib/attribution";

// Seiten ohne Kurs-Bezug: Rabatt-Hinweis hier nicht zeigen.
const HIDDEN_PREFIXES = ["/services", "/impressum", "/datenschutz", "/agb", "/barrierefreiheit"];

// Dezenter Hinweis für Besucher über einen Creator-Link: Rabatt ist aktiv.
export const RefDiscountBanner = () => {
  const [visible, setVisible] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => {
    try {
      if (getAffiliateRef() && !sessionStorage.getItem("dh-ref-banner-dismissed")) {
        setVisible(true);
      }
    } catch {
      /* noop */
    }
  }, []);

  if (!visible || HIDDEN_PREFIXES.some((p) => pathname.startsWith(p))) return null;

  const dismiss = () => {
    setVisible(false);
    try {
      sessionStorage.setItem("dh-ref-banner-dismissed", "1");
    } catch {
      /* noop */
    }
  };

  return (
    <div
      data-testid="ref-discount-banner"
      className="fixed bottom-4 left-1/2 -translate-x-1/2 z-50 flex items-center gap-2.5 rounded-full bg-sand-800 text-cream-50 pl-4 pr-2 py-2.5 shadow-lg max-w-[92vw]"
    >
      <BadgePercent className="h-4.5 w-4.5 shrink-0 text-terra" style={{ width: 18, height: 18 }} />
      <span className="text-[13px] leading-snug">
        Dein <strong>10&nbsp;% Rabatt</strong> ist aktiviert – wird beim Buchen automatisch abgezogen.
      </span>
      <button
        type="button"
        data-testid="ref-discount-banner-close"
        onClick={dismiss}
        aria-label="Hinweis schließen"
        className="shrink-0 rounded-full p-1.5 hover:bg-white/10"
      >
        <X className="h-4 w-4" />
      </button>
    </div>
  );
};
